module.exports = __webpack_public_path__ + "static/media/Configuración_ISN.443f1a89.svg";